module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "persistent": "",
      "height": "100%",
      "clipped": "",
      "temporary": "",
      "light": "",
      "overflow": ""
    },
    model: {
      value: (_vm.localDrawer),
      callback: function($$v) {
        _vm.localDrawer = $$v
      },
      expression: "localDrawer"
    }
  }, [_c('div', {
    ref: "animator",
    class: ['loader', ("loader--" + (_vm.settingsObj.themeColor)), 'animation-example', 'loader-ball']
  }, [_c('v-icon', {
    class: ['animation-example__body', ((_vm.settingsObj.themeColor) + "--text"), ("animated " + (_vm.settingsObj.animation) + " infinite")]
  }, [_vm._v(_vm._s(("" + (_vm.getFunIcon()))) + "\n        ")])], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "transparent"
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "https://s.gravatar.com/avatar/edebe1c8b202a4ffb065b200c8d12d57?s=80"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Settings")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.label,
      attrs: {
        "id": _vm.snakeCase(item.label.toLowerCase())
      },
      on: {
        "click": function () {
          _vm.openLink(item.path, true);
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      class: [((_vm.settingsObj.themeColor) + "--text"), 'text--lighten-1']
    }, [_vm._v(_vm._s(item.icon) + "\n                ")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(item.label))])], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("Customize this App")]), _vm._v(" "), _c('v-list', {
    staticClass: "px-3"
  }, [_c('v-select', {
    staticClass: "controls",
    attrs: {
      "label": "Select A Theme",
      "items": _vm.colors,
      "item-text": "color",
      "item-value": "color",
      "hint": ("Currently: " + (_vm.settingsObj.themeColor)),
      "single-line": "",
      "persistent-hint": "",
      "hide-details": ""
    },
    on: {
      "input": function (e) {
        _vm.emitEvent('updateConfigVal', {
          'themeColor': e
        })
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-tile-content', [_c('v-btn', {
            staticClass: "dropdown-btn",
            style: ({
              'background-color': data.item.hexValue
            }),
            attrs: {
              "fab": ""
            }
          })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "textContent": _vm._s(data.item.color)
            }
          })], 1)]
        ]
      }
    }])
  })], 1), _vm._v(" "), _c('v-list', {
    staticClass: "px-3"
  }, [_c('v-select', {
    staticClass: "controls",
    attrs: {
      "label": "Select An Animation",
      "items": _vm.animations,
      "hint": ("Currently: " + (_vm.settingsObj.animation)),
      "single-line": "",
      "persistent-hint": "",
      "hide-details": ""
    },
    on: {
      "input": function (e) {
        _vm.showAnimation();
        _vm.emitEvent('updateConfigVal', {
          'animation': e
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })], 1)]
        ]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": ""
    }
  }, [_c('v-switch', {
    staticClass: "controls",
    attrs: {
      "color": _vm.settingsObj.themeColor,
      "id": "to-top",
      "label": "Return To Top Button"
    },
    on: {
      "change": function (e) {
        _vm.emitEvent('updateConfigVal', {
          'toTop': e
        })
      }
    },
    model: {
      value: (_vm.settingsObj.toTop),
      callback: function($$v) {
        _vm.$set(_vm.settingsObj, "toTop", $$v)
      },
      expression: "settingsObj.toTop"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": ""
    }
  }, [_c('v-switch', {
    staticClass: "controls",
    attrs: {
      "color": _vm.settingsObj.themeColor,
      "label": "Remember Settings"
    },
    on: {
      "change": function (e) {
        _vm.emitEvent('updateConfigVal', {
          'rememberSettings': e
        })
      }
    },
    model: {
      value: (_vm.settingsObj.rememberSettings),
      callback: function($$v) {
        _vm.$set(_vm.settingsObj, "rememberSettings", $$v)
      },
      expression: "settingsObj.rememberSettings"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": ""
    }
  }, [_c('v-switch', {
    staticClass: "controls",
    attrs: {
      "color": _vm.settingsObj.themeColor,
      "label": "Remember Location"
    },
    on: {
      "change": function (e) {
        _vm.emitEvent('updateConfigVal', {
          'rememberLocation': e
        })
      }
    },
    model: {
      value: (_vm.settingsObj.rememberLocation),
      callback: function($$v) {
        _vm.$set(_vm.settingsObj, "rememberLocation", $$v)
      },
      expression: "settingsObj.rememberLocation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": ""
    }
  }, [_c('v-switch', {
    staticClass: "controls",
    attrs: {
      "color": _vm.settingsObj.themeColor,
      "label": "Show Info Button"
    },
    on: {
      "change": function (e) {
        _vm.emitEvent('updateConfigVal', {
          'infoBtn': e
        })
      }
    },
    model: {
      value: (_vm.settingsObj.infoBtn),
      callback: function($$v) {
        _vm.$set(_vm.settingsObj, "infoBtn", $$v)
      },
      expression: "settingsObj.infoBtn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "tour-container"
  }, [_c('v-btn', {
    class: [_vm.settingsObj.themeColor, 'darken-2', 'white--text'],
    on: {
      "click": function (e) {
        _vm.emitEvent('startTour', true)
      }
    }
  }, [_vm._v(" Start the Tour!\n            ")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32e766a7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavDrawer.vue
// module id = 460
// module chunks = 0